import React, { useRef, useState, useMemo, useEffect } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService.jsx";
import DataGridComponent from '../../common/DataGridComponent/DataGridComponent.jsx';
import Spinner2 from "../../common/Spinner/Spinner2.jsx";
import commonApiService from '../../../../shared/common-utilities/services/commonApiService.jsx';
import { getDepot, fetchSavedView  } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts.jsx';
import { Grid } from '@mui/material';
import AlertComponent from '../../../../shared/common-utilities/common/AlertComponent.jsx';
import ActionButton from '../../../../shared/common-utilities/common/ActionButton.jsx';

const entity = "transportAddress";
let entityNameFor = "transportAddress";
const odataApiName = "transportAddress";
let odataApiNameFor = "transportAddress";
let service = getSetDataService();
let apiService = commonApiService();
const dataRelatedAction = ['Filter', 'View Columns', 'Settings', 'Refresh', 'New Window'];
let gridSelectedValues = {};
//#region SortData start

const TransportAddress = (props) => {
  //#region Reference
  const subContractorGrid = useRef(null);
  //#endregion Reference

  //#region Hook Selctor
  //#endregion Hook Selctor

  const transportAddressDataItemKey = "id";
  const initialSort = service.initialSort[entity];

  //#region States - Get set variables
  const [tempTransAddressData, setTempTransAddressData] = useState([]);
  const [transAddressGridColumnList, setTransAddressGridColumnList] = React.useState(null);
  const [tempTransAddressGridColumnList, setTempTransAddressGridColumnList] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isTransAddress, setIsTransAddress] = useState(true);
  const [loadedGridData, setLoadedGridData] = useState(tempTransAddressData);
  const [myGridData, setmyGridData] = React.useState([]);
  const [loadSelectionValue, setloadSelectionValue] = useState(100);
  const [totalData, setTotalData] = useState();
  const userID = localStorage.getItem('userID');
  
  const [isApiLoaded, setIsApiLoaded] = useState(false);
  const [paramsData, setParamsData] = useState(null);
  let [initialFilter, setInitialFilter] = useState([]);
  const [nextDataUrl, setNextDataUrl] = useState(null);
  const [transAddressData,setTransAddressData] = useState({});
  const [initialSaveViewData, setInitialSaveViewData] = useState([]);
  const [initialFetchReadLinkData, setInitialFetchReadLinkData] = useState(null);
  const [isErrorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [errorSnackbarMessage, setErrorSnackbarMessage] = useState('');
  const [changeToChildTA, setChangeToChildTA] = useState(null);
  const [isApiCallRequired, setIsApiCallRequired] = useState(true);

  const TransAddressFilterComponents = [];
  //#endregion States

  //#region Hooks  

  useEffect(() => {
    // setIsLoading(true);

    setIsApiLoaded(true);
    entityNameFor = entity + (props?.params?.for ? props?.params?.for : '');
    odataApiNameFor = odataApiName + (props?.params?.for ? props?.params?.for : '');
    setGridColumns(entity);

    let tempFilterData = [];
    setInitialFilter(tempFilterData);
  }, []);

  const setGridColumns = (entityName) => {
    const columnList = localStorage.getItem(entityNameFor + 'ColumnList');
    if (!_.isNil(columnList)) {
      setTransAddressGridColumnList(JSON.parse(columnList));
      getColList(JSON.parse(columnList));
      return true;
    }

    apiService.getODataMetadata().then(odataRes => {
      service.entityDefinitions(odataRes, entityName).then((tempFieldList) => {
        localStorage.setItem(entityNameFor + 'ColumnList', JSON.stringify(tempFieldList));
        setTransAddressGridColumnList(tempFieldList);
        getColList(tempFieldList);
      })
    })
    .catch(error => {
      console.error('API error:', error);
    })
  }

  const getDefaultColList = (dcolsStringSC, gridcolumns) => {
    const dCols = JSON.parse(localStorage.getItem("defaultColumnSetting"));
    if (!_.isNil(dcolsStringSC) && dcolsStringSC != "undefined" ) {
      const defaultColumnListSC = gridcolumns?.filter(item => {
        return dCols[entity]?.split("~").includes(item.field);
      });
      if (defaultColumnListSC.length == 0) {
        localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(gridcolumns));
        setTempTransAddressGridColumnList(gridcolumns);
      } else {
        const sortedArr = _.sortBy(defaultColumnListSC, function (item) { return dCols[entity]?.split("~").indexOf(item.field) });
        localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(sortedArr));
        setTempTransAddressGridColumnList(sortedArr);

        const arr1 = sortedArr;
        const arr2 = gridcolumns.filter(e => !sortedArr.map(x => x.field).includes(e.field));
        const newsortedArr = _.concat(arr1, arr2);
        setTransAddressGridColumnList(newsortedArr);
      }
    } else {
      localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(gridcolumns));
      setTempTransAddressGridColumnList(gridcolumns);
    }
  }

  const getColList = (gridcolumns) => {
    const scUrl = `${fetchSavedView}?$filter=(title eq '${odataApiNameFor}' and userID eq '${userID}')`;
    const dcolsStringSC = localStorage.getItem("defaultColumnSetting");
    apiService.get(scUrl).then(savedViewRes => {
      if (savedViewRes?.value?.length > 0) {
        apiService.get(savedViewRes.value[0]["userMetadata@odata.mediaReadLink"], null, null, null, null, savedViewRes.value[0]["@odata.etag"]).then(readResSC => {
          if (readResSC !== undefined && readResSC !== null) {
            setInitialSaveViewData(savedViewRes.value);
            setInitialFetchReadLinkData(readResSC);
            const defaultViewExist = readResSC[odataApiNameFor]?.savedViews?.filter(item => item.defaultView);
            if (defaultViewExist?.length > 0 && defaultViewExist?.[0]?.subviews?.length > 0) {
              const favFilterExist = defaultViewExist[0]?.subviews?.filter(subView => subView.isDefaultFilter);
              if (favFilterExist?.length > 0) {
                setTempTransAddressGridColumnList(defaultViewExist[0].columns);
              }
            } else if (readResSC[odataApiNameFor]?.columns?.length !== 0) {
              localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(readResSC[odataApiNameFor]?.columns));
              setTempTransAddressGridColumnList(readResSC[odataApiNameFor]?.columns);
            } else {
              getDefaultColList(dcolsStringSC, gridcolumns);
            }
          }
        })
      } else {
        getDefaultColList(dcolsStringSC, gridcolumns);
      }

      setIsLoading(false);
    });
  }

  useEffect((e) => {
    if (!_.isNil(paramsData) && isApiCallRequired) {
      updateSendApi(loadSelectionValue);
    } else {
      setIsApiCallRequired(true);
    }
  }, [paramsData]);

  useEffect((e) => {
    if (!_.isNil(tempTransAddressGridColumnList)) {
      setNextDataUrl(null);
      updateSendApi(loadSelectionValue);
    }
  }, [tempTransAddressGridColumnList]);

  // --- API's Call START ---
  
  const sendApi = (val, size) => {
    let filter = paramsData?.filter ? '$filter=(' + paramsData?.filter + ')' : null;
    let orderby = paramsData?.orderby ? '$orderby=' + paramsData?.orderby : null;
    if (tempTransAddressGridColumnList !== null && tempTransAddressGridColumnList !== undefined && tempTransAddressGridColumnList?.length > 0) {
      setIsLoading(true);
      const params = '&' + filter + '&' + orderby + '&$count=true';
      const columns = tempTransAddressGridColumnList?.map(item => item.field);
      const mandatroyEntity = JSON.parse(localStorage.mandatoryColumnList).find(e => e.entity == odataApiName);
      if (!_.isNull(mandatroyEntity)) {
        let splitedColums = mandatroyEntity.mandatoryColumns.split("~");
        splitedColums.forEach(element => {
          if (!columns.includes(element)) {
            columns.push(element)
          }
        });
      }

      const selectFields = `&$select=${columns}`;
      const oDataNextLink = val == 'Scroll' ? nextDataUrl : null;
      apiService.get(getDepot, params, `${selectFields}`, oDataNextLink, size, null).then(response => {
        if (response !== null && response !== undefined && response.error !== null && response.error !== undefined && response.error) {
          setErrorParameterAndMessage(response?.error?.message.split('CorrelationId')[0]);
          if (response?.error?.message?.includes('$orderby')) {
            const sortToRemoveSC = response.error.message.split("'")[1];
            setChangeToChildTA({ type: "sort", value: sortToRemoveSC });
          } else if (response?.error?.code == "Application_FilterErrorException") {
            const filterToRemoveSC = response.error.message.split("'")[1];
            setChangeToChildTA({ type: "filter", value: filterToRemoveSC });
          }
        } else {
          if (response.value) {
            setTotalData(response["@odata.count"]);
            let tempData = [];
            if (val == 'Scroll' && tempTransAddressData !== null && tempTransAddressData !== undefined && tempTransAddressData.length > 0) {
              tempTransAddressData.forEach(tempContractor => {
                tempData.push(tempContractor);
              });
              response.value.map(temp => {
                tempData.push(temp)
              })
            }
            // Update the data based on the response
            else {
              tempData = response.value;
            }

            tempData = service.setColorCodeAndDate(tempData, transAddressGridColumnList);
            setIsApiLoaded(true);
            if (response['@odata.nextLink'] !== null && response['@odata.nextLink'] !== undefined) {
              setNextDataUrl(response['@odata.nextLink']);
            }

            setmyGridData(tempData);
            setLoadedGridData(tempData);
            setTempTransAddressData(tempData);
          }
        }
      })
        .catch(error => {
          console.error('API error:', error);
        })
        .finally(() => {
          setIsLoading(false);
          if (props?.sendDataToParent) {
            props.sendDataToParent(odataApiName);
          }
        });
    } else {
      setIsLoading(false);
    }
  }

  const updateSendApi = useMemo(() => {
    return _.debounce((size) => {
      sendApi(null, size);
    }, 250);
  }, [sendApi]);
  
  // --- API's Call END ---

  //#endregion Hooks

  const childStateHandler = (value, flag) => {
    if (flag === 'showGridHeader') {
      setIsTransAddress(value);
    } else if (flag === 'getData') {
      setNextDataUrl(null);
      setParamsData({ ...paramsData, filter: value.filter, orderby: value.orderby });
      setIsApiCallRequired(value.isApiCall);
      setTempTransAddressGridColumnList(value.columns);
    } else if (flag === 'refresh') {
      sendApi(null, loadSelectionValue);
    } else if (flag === 'selectedValues') {
      gridSelectedValues = value;
    } else if (flag === 'dataItem') {
      setTransAddressData(value); 
    } else if (flag === 'columnsVisible') {
      setTempTransAddressGridColumnList(value);
    }
  }

  const closePopup = () => {
    props.onClose();
  }

  const onOkClick = () => {
    let transferdataId = Object.entries(gridSelectedValues).filter(([key, value]) => value === true).map(([key]) => key);
    if (transferdataId.length === 0) {
      setErrorSnackbarMessage('Please select Transport Address');
      setErrorSnackbarOpen(true);
      return;
    }
    let addressObj = {
      transportAddress : transAddressData.id
    }
    let obj = {
      "input" :  JSON.stringify(addressObj)
    }
    const parsedInput1 = JSON.parse(props.params?.obj.input);
    const parsedInput2 = JSON.parse(obj.input);
    const mergedInput = {...parsedInput1, ...parsedInput2};
    const jsonString = ({input: JSON.stringify(mergedInput)});

    props.closeConfirmationModal(jsonString, props.params?.for)
    props.onClose();
  }
  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setErrorSnackbarOpen(false);
  };

  const onLoadSelectionChange = (e) => {
    let value = e.value;
    setloadSelectionValue(value);
    sendApi(null, value);
  }

  const setErrorParameterAndMessage = (errMsg) => {
    setCommonPopupParameters({
      title: 'Error'
    });
    setErrorMessage(errMsg);
    setopenConfirmationModal(true);
  }

  return (
    <>
      {isLoading ? (<Spinner2 isAll={loadSelectionValue} />) : (<></>)}
      <Grid item xs={12} square component={Card} elevation={0} sx={{ p: 1, width: '100%' }} id={odataApiName}>

        <AlertComponent isErrorSnackbarOpen={isErrorSnackbarOpen} errorSnackbarMessage={errorSnackbarMessage} handleErrorSnackbarClose={handleErrorSnackbarClose} />

        {isTransAddress && <Box className="headBG" sx={{ px: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="body2" color="secondary.contrastText" sx={{ fontWeight: 500 }}>Transport Address</Typography>
        </Box>}
        <Grid container sx={{ marginTop: 0 }}  >
          <Grid item={true} xs component={Card} elevation={0} pl={0} sx={{ flexGrow: 1 }} className='grid-movement'>
            {isApiLoaded && <DataGridComponent
              {...props}
              gridRef={subContractorGrid}
              gridFlagVal={odataApiName}
              gridFlagValFor={odataApiNameFor}
              gridStyle={{ maxHeight: 'calc(100%)', height: '100%', minHeight: '650px' }}
              gridNewData={myGridData}
              loadedGridData={loadedGridData}
              tempGridData={tempTransAddressData}
              gridColumnList={transAddressGridColumnList ? transAddressGridColumnList : []}
              gridTempColumnList={tempTransAddressGridColumnList ? tempTransAddressGridColumnList : []}
              isItemVisible={true}
              gridSort={initialSort}
              gridInitialFilter={initialFilter}
              isShowGridHeader={isTransAddress}
              griddDtaItemKey={transportAddressDataItemKey}
              gridDraggable={false}
              sendDataToParent={childStateHandler}
              gridDataAction={dataRelatedAction}
              gridFilterComponents={TransAddressFilterComponents}
              onLoadSelectionChange={onLoadSelectionChange}
              loadSelectionValue={loadSelectionValue}
              gridtotalData={totalData}
              initialSaveViewData={initialSaveViewData}
              initialFetchReadLinkData={initialFetchReadLinkData}
              selectableMode={"single"}
              changeToChild={changeToChildTA}
            />}
          </Grid>
        </Grid>
      </Grid>
      <ActionButton onOkClick={onOkClick} closePopup={closePopup}/>
    </>
  )
};

export default TransportAddress;